export default {
  partSpecification: 'Špecifikácia dielu',
  treatmentInformation: 'Informácie o tepelnom spracovaní',
  partImages: 'Fotografie dielu',
  treatmentRemark: 'Poznámka k spracovaniu',
};
